import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IframeQueueService {
    private _inEvent: BehaviorSubject<string | null>;
    private _outEvent: BehaviorSubject<string | null>;

    constructor() {
        this._inEvent = new BehaviorSubject<string | null>(null);
        this._outEvent = new BehaviorSubject<string | null>(null);
    }

    clearQueueIn(): void {
        this._inEvent.next(null);
    }

    clearQueueOut(): void {
        this._outEvent.next(null);
    }

    listenForIframeQueueInEvent(): Observable<string | null> {
        return this._inEvent.asObservable();
    }

    listenForIframeQueueOutEvent(): Observable<string | null> {
        return this._outEvent.asObservable();
    }

    nextIn(url: string): void {
        this._inEvent.next(url);
    }

    nextOut(payload: string): void {
        this._outEvent.next(payload);
    }
}
